// Modal shell + header ported from the ImageShield reference design.
import React, { useEffect } from "react";
import { Icons } from "./Icons";

export function ModalShell({ open, onClose, children, maxWidth = "max-w-2xl" }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose?.();
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 fade-in">
      <div className="absolute inset-0 bg-slate-900/30 backdrop-blur-sm" onClick={onClose} />
      <div
        className={`relative bg-white rounded-2xl border border-gray-200 shadow-card-hover w-full ${maxWidth} max-h-[92vh] overflow-y-auto scale-in`}
      >
        {children}
      </div>
    </div>
  );
}

export function ModalHeader({ title, subtitle, onClose }) {
  return (
    <div className="flex items-start justify-between p-6 border-b border-gray-100">
      <div>
        <h2 className="text-lg font-bold text-slate-900">{title}</h2>
        {subtitle && <p className="text-sm text-slate-500 mt-0.5">{subtitle}</p>}
      </div>
      <button
        onClick={onClose}
        className="w-9 h-9 grid place-items-center rounded-lg text-slate-500 hover:bg-gray-100"
        aria-label="Close"
      >
        <Icons.X className="w-4 h-4" />
      </button>
    </div>
  );
}
